(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mba_text = {
    attach: function (context, settings) {

      // Convert table002 to table002 if inside tabs slick.
      $('.mbo-tabs-001--tabs table.table002').removeClass('table002').addClass('table001 table002--as001');

      // Attach scroll fade divs to table
      $('.field--type-text-long > table').once('table001-002-table-scroll').wrap('<div class="table-scroll"></div>').after('<div class="fade-left"></div><div class="fade-right"></div>');
      $('.field--type-text-long > .table-scroll').once('table001-002-table-scroll-wrapper').wrap('<div class="table-wrapper"></div>');

      // Trigger on load
      $('.table-scroll').each(function() {
        // Add table class to the container div
        if($(this).find('table').hasClass('table001')){
          $(this).addClass('table001');
        }
        else if ($(this).find('table').hasClass('table002')){
          $(this).addClass('table002');
        }
        // Adds class & right fade on load if table width is greater than the container.
        if($(this).width() < $(this).find('table').width()) {
          $(this).addClass('scrolling');
          $(this).find('.fade-right').show();
          // Freeze left column of table 002
          $(this).find('table.table002').fixedHeaderTable({
            fixedColumns:    1, // fixed first columns
            fixedColumn:     true // For backward-compatibility
          });
        }
      });

      // Trigger fade on resize for table001
      $(window).resize(function() {
        $('.table-scroll.table001').each(function() {
          if($(this).width() < $(this).find('table').width()) {
            // Adds class & right fade on load if table width is greater than the container.
            $(this).addClass('scrolling');
            $(this).find('.fade-right').show();
            // Freeze left column of table 002
            // $(this).find('table.table002').fixedHeaderTable({
            //   fixedColumns:    1, // fixed first columns
            //   fixedColumn:     true // For backward-compatibility
            // });
            desktopScroll();
          }
          else {
            // Removes class & right fade on load if table width is less than the container
            $(this).removeClass('scrolling');
            $(this).find('.fade-right').hide();
          }
        });
      });

      // Trigger fade on resize for table002
      $(window).resize(function() {
        $('.table-scroll.table002').each(function() {

          if ($(this).width() < $(this).find('table').width()) {

            if ( $('.fht-table-wrapper', this).length == 0 ) {
              // Freeze left column of table 002
              $(this).find('table.table002').fixedHeaderTable({
                fixedColumns:    1, // fixed first columns
                fixedColumn:     true // For backward-compatibility
              });

              $('.table001.table-scroll, .table002.table-scroll .fht-table-wrapper .fht-tbody, .table002.table-scroll .fht-table-wrapper .fht-fixed-body').on( 'scroll resize', function() { // Fires each time the container is scrolled.
                showHideFades(this);
              }).scroll();
            }

          }

         if ($(this).find('.fht-fixed-body .fht-tbody .table002.fht-table').width() > $(this).find('.fht-fixed-body .fht-tbody').width()) {
            $(this).removeClass('no-scroll').addClass('scrolling');
            $(this).find('.fade-right').show();
          }
          else {
            $(this).addClass('no-scroll').removeClass('scrolling');
            $(this).find('.fade-right').hide();
          }
        });
      });

      // Trigger on element scroll
      $('.table001.table-scroll, .table002.table-scroll .fht-table-wrapper .fht-tbody, .table002.table-scroll .fht-table-wrapper .fht-fixed-body').on( 'scroll resize', function() { // Fires each time the container is scrolled.
        showHideFades(this);
      }).scroll();

      function showHideFades(element) {
        if($(element).scrollLeft() == 0) {
          $(element).closest('.table-scroll').find('.fade-left').hide();// Fires when the container is at its left most scroll position.
        }
        else if($(element).scrollLeft() >= ($(element).find('table').width() - $(element).width())) {
          $(element).closest('.table-scroll').find('.fade-right').hide();// Fires when the container is at its right most scroll position.
        }
        else if($(element).closest('.table-scroll').find('.fade-left').css('display') != 'block') {
          $(element).closest('.table-scroll').find('.fade-left').show(); // Fires when the container is at any other scroll position and the element is hidden.
        }
        else if($(element).closest('.table-scroll').find('.fade-right').css('display') != 'block') {
          $(element).closest('.table-scroll').find('.fade-right').show(); // Fires when the container is at any other scroll position and the element is hidden.
        }
      }

      // If not a real touch device, do scroll using jquery.touchSwipe
      function desktopScroll() {
        if ($('body').hasClass('touch-disabled')) {
          $('.table-scroll, .table002.table-scroll .fht-table-wrapper .fht-tbody, .table-scroll .fht-table-wrapper .fht-fixed-body').each(function(index, value){
            $(value, context).swipe({
              swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
                if (direction == 'left') {
                  $(this).animate({ scrollLeft: $(this).scrollLeft() + distance });
                } else if (direction == 'right') {
                  $(this).animate({ scrollLeft: $(this).scrollLeft() - distance });
                }
              },
              threshold: 0
            });
          });
        }
      }
      desktopScroll();

      // Fire resize on accordion and tabs
      $('body').once('table001-table002-accordions').on('click', '.mbm-accordion-header', function(index, value){
        setTimeout(function () {
          if ($('.open > .mbm-accordion-content .table-scroll').length) {
            $(window).trigger('resize');
          }
        }, 200);

      });
      $('body').once('table001-table002-tabs').on('click', '.mbo-tabs-001--titles > li', function(index, value){
        setTimeout(function () {
          if ($('.mbo-tabs-001--tabs .slick-current.slick-active .table-scroll').length) {
            $(window).trigger('resize');
          }
        }, 200);
    });

    }
  }; //Drupal.behaviors.mba_text.

})(jQuery, Drupal, drupalSettings);
